﻿export class LPXv1_ABI
{
    public static GetABI():any
    {
        return [
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "token",
				"type": "uint256"
			}
		],
		"name": "approvedTokens",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			}
		],
		"name": "configs",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "pack",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "manager",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "fundToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalShares",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Config",
				"name": "config_",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			}
		],
		"name": "getConfigShort",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "pack",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalShares",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.ConfigShort",
				"name": "config_",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "token_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "skip_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "take_",
				"type": "uint256"
			}
		],
		"name": "getPoolIds",
		"outputs": [
			{
				"internalType": "uint256[]",
				"name": "poolIds_",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256[]",
				"name": "poolIds_",
				"type": "uint256[]"
			}
		],
		"name": "getPoolsByIds",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "pack",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "manager",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "fundToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalShares",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Config[]",
				"name": "configs_",
				"type": "tuple[]"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "fundReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundImgReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorImgReserve",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Reserve[]",
				"name": "reserves_",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "pairIndex_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "skip_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "take_",
				"type": "uint256"
			}
		],
		"name": "getPoolsByPair",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "pack",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "manager",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "fundToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalShares",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Config[]",
				"name": "configs_",
				"type": "tuple[]"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "fundReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundImgReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorImgReserve",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Reserve[]",
				"name": "reserves_",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "token_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "skip_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "take_",
				"type": "uint256"
			}
		],
		"name": "getPoolsByToken",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "pack",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "manager",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "fundToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalShares",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Config[]",
				"name": "configs_",
				"type": "tuple[]"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "fundReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundImgReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorImgReserve",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Reserve[]",
				"name": "reserves_",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "user_",
				"type": "address"
			}
		],
		"name": "getShare",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "debt",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "pending",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Share",
				"name": "share_",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "rps_",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "lastPoolId",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			}
		],
		"name": "profitPerShare",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "rps_",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			}
		],
		"name": "reserves",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "fundReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundImgReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorImgReserve",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Reserve",
				"name": "reserve_",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "userAddress",
				"type": "address"
			}
		],
		"name": "shares",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "debt",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "pending",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1_Short.Share",
				"name": "share_",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];
    }
}